export default __webpack_public_path__ + "static/MediaContentEleven-f3ee823905fec90b5be974dfd627bbb9.webp";